<template>
    <div class="xc-modal xc-modal-page">
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">下载详情</div>
                    <div
                class="xc-modal-close"
                @click="layerClose"
              ></div>
                </div>
                <div class="xc-modal-body">
                    <div class="xc-info">
                        <div class="xc-info-content">
                            <div class="xc-info-row">
                                <div class="xc-info-item">
                                    节目名称：{{programInfo.programName}}，共{{programInfo.sourceList?programInfo.sourceList.length:0}}个广告素材
                                </div>
                            </div>
                            <div class="xc-info-row">
                                <div class="xc-info-item">
                                    投放信息：共{{programInfo.deviceGroupCount}}个分组，{{programInfo.deviceCount}}个终端
                                </div>
                                <div class="xc-info-item">
                                    投放开始时间：{{programInfo.putinStartTime}}
                                </div>
                                <div class="xc-info-item">
                                    投放结束时间：{{programInfo.putinEndTime}}
                                </div>
                                <div class="xc-info-item">
                                    投放限制：{{programInfo.putinLimitName}}
                                </div>
                            </div>
                            <div class="xc-info-row">
                                <div class="xc-info-item">
                                    下载信息： 已下载成功：{{statisticsInfo.downloadSuccessCount}}个终端；下载中：{{statisticsInfo.downloadingCount}}个终端；下载失败：{{statisticsInfo.downloadFailCount}}个终端；
                                </div>
                            </div>
                        </div>
                    </div>
                    <form
                        name="publish"
                        class="xc-form"
                    >
                        <div class="xc-form-inline">
                            <!-- <xc-form-item label="终端名:">
                                <input
                                    type="text"
                                    class="xc-input"
                                    placeholder="请输入终端名"
                                    v-model="mix_query.deviceName"
                                >
                            </xc-form-item> -->
                            <xc-form-item label="终端序列号:">
                                <input
                                    type="text"
                                    class="xc-input"
                                    placeholder="请输入终端序列号"
                                    v-model="mix_query.deviceCode"
                                >
                            </xc-form-item>
                            <div class="xc-btn-group">
                                <button
                                    type="submit"
                                    class="xc-btn xc-btn-primary"
                                    @click.prevent="mix_search"
                                >查询
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="xc-row-scroll">
                        <table class="xc-table">
                            <thead>
                                <th>终端组</th>
                                <th>设备MAC</th>
                                <th>设备IP</th>
                                <th>终端状态</th>
                                <th>终端序列号</th>
                                <th>下载状态</th>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,index) in list"
                                        :key="index"
                                    >
                                        <td>
                                            {{item.deviceGroupName}}
                                        </td>
                                        <td>
                                            {{item.deviceMac}}
                                        </td>
                                        <td>
                                            {{item.ip}}
                                        </td>
                                        <td>
                                            {{item.deviceStatus}}
                                        </td>
                                        <td>
                                            {{item.deviceSerialNum}}
                                        </td>
                                        <td>
                                            {{item.downloadStatus}}
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="20"
                                            class="xc-s-tac"
                                        >暂无数据
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="xc-modal-footer xc-flex-item">
                    <div class="xc-btn-group">
                        <button
                            type="button"
                            class="xc-btn xc-btn-default"
                            @click="close"
                        >关闭</button>
                    </div>
                    <!-- 分页 -->
                    <xc-pagination
                        @change="mix_pageChange"
                        :page="mix_page"
                        :total="mix_total"
                        :size="mix_pageSize"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from '../xc-ui/mixins/list';
import myLayerImport from "@/libs/myLayer"
import programApi from '../api/program';
import '@/utils/ip-format';

export default {
    name: "programPublishDetail",
    mixins: [listMixin],
    data() {
        return {
            // 列表key
            mix_listKey: 'list',

            // 列表唯一字段
            mix_listId: 'programVersion',

            // 默认查询参数
            mix_query: {

            },

            // 列表数据
            list: [],


            programInfo: {},

            statisticsInfo: {},
        }
    },
    methods: {
        layerClose() {
            var index = parent.layer.getFrameIndex(window.name);
            parent.layer.close(index);
        },
        // 列表初始化数据
        initData() {

            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                programVersion: this.$route.params.programVersion,
                ...this.mix_query,
            }

            programApi.putinDevicesByProgram(search).then(ret => {
                //添加mix_checkbox属性
                this.list = this.mix_format(ret.data.list);
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            })
        },
        close: function () {
            parent.myLayer.close(this.index);
        },
        //    查询下发详情
        publishSubmit: function () {

        },
    },
    async mounted() {
        await myLayerImport();
        this.index = parent.myLayer.getFrameIndex(window.name);
    },
    created() {
        programApi.programDetail({
            programVersion: this.$route.params.programVersion
        }).then(v => {
            this.programInfo = v.data;
        })

        programApi.statisticsInfo({
            programVersion: this.$route.params.programVersion
        }).then(v => {
            this.statisticsInfo = v.data;
        })
    }
}
</script>

<style scoped lang="scss">
.xc-row {
    margin-bottom: 0;
}
.xc-page-footer {
    border-top: 1px solid #eef2f9;
}
</style>
